module.exports = __webpack_public_path__ + "img/kernelback4.3f88594b.png";